import React from "react";

export const PicOutPicIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.99174 3.99172L1.99176 4.00828L2.00832 10.0083"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 4L8 10"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 10V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H12"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 14V16C3 16.5304 3.21071 17.0391 3.58579 17.4142C3.96086 17.7893 4.46957 18 5 18H8"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 14H13C12.4477 14 12 14.4477 12 15V20C12 20.5523 12.4477 21 13 21H21C21.5523 21 22 20.5523 22 20V15C22 14.4477 21.5523 14 21 14Z"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
